module.exports = __webpack_public_path__ + "static/media/perlite.efc465ea.jpg";